export const NAME = "internal_tools";

// Action Types
export const TRIGGER_INTERNAL_TOOL_MODAL = `TRIGGER_INTERNAL_TOOL_MODAL ${NAME}`;
export const CLOSE_INTERNAL_TOOL_MODAL = `CLOSE_INTERNAL_TOOL_MODAL ${NAME}`;

// Modal types
export const VIEW_AND_MIGRATE_TERM_ASSOCIATED_DATA_MODAL =
  "VIEW_AND_MIGRATE_TERM_ASSOCIATED_DATA_MODAL";
export const RATINGS_LOGS_MODAL = "RATINGS_LOGS_MODAL";
export const REMARKS_LOGS_MODAL = "REMARKS_LOGS_MODAL";
export const TEMPLATE_LOGS_MODAL = "TEMPLATE_LOGS_MODAL";
